import {
  makeAuthenticatedRequest,
  makeAuthenticatedRequestForFile,
} from "./api";

export const uploadProfilePicture = async (file) => {
  try {
    const formData = new FormData();
    formData.append("image", file, file.name);
    const response = await makeAuthenticatedRequestForFile(
      "/users/profile_picture",
      "POST",
      formData,
    );
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || "Failed to upload image");
    }
    const data = await response.json();
    return { success: true, url: data.url, s3Key: data.s3Key };
  } catch (error) {
    console.error("Error uploading profile picture:", error);
    return { success: false, error: error.message };
  }
};

export const getAllUsers = async (props) => {
  const {
    role,
    search = "",
    status = "",
    pageNumber,
    pageSize,
    classroomId = "",
    teacher = "",
    subscription = "",
    startDateTime = "",
    endDateTime = "",
    classroom = "",
    organisations = "",
  } = props;

  let url = `/users?roleName=${role}&search=${search}&pageNumber=${pageNumber}&pageSize=${pageSize}&status=${status}&classroomId=${classroomId}&teacher=${teacher}&subscription=${subscription}&startDateTime=${startDateTime}&endDateTime=${endDateTime}&organisationId=${organisations}`;
  if (classroom) {
    url += `&classroom=${classroom}`;
  }
  try {
    return await makeAuthenticatedRequest(url)
      .then((response) => {
        // Check if the request was successful (status code 200-299)
        if (!response.ok) {
          return { ok: false, error: response };
        }
        // Parse the response as JSON
        return response.json();
      })
      .then((data) => {
        // Handle the JSON data
        return { ok: true, data: data };
      })
      .catch((error) => {
        // Handle errors
        console.error("Fetch error roles:", error);
        return { ok: false, error: error };
      });
  } catch (error) {
    // Handle network errors or unexpected issues
    console.error("Error during roles:", error);
    return { ok: false, error: error };
  }
};

export const getForbiddenUsers = async (props) => {
  const { organisation = "", pageNumber, pageSize } = props;

  let url = `/organisations/users/forbidden_logins?organisationId=${organisation}&pageNumber=${pageNumber}&pageSize=${pageSize}`;
  try {
    return await makeAuthenticatedRequest(url)
      .then((response) => {
        // Check if the request was successful (status code 200-299)
        if (!response.ok) {
          return { ok: false, error: response };
        }
        // Parse the response as JSON
        return response.json();
      })
      .then((data) => {
        // Handle the JSON data
        return { ok: true, data: data };
      })
      .catch((error) => {
        // Handle errors
        console.error("Fetch error roles:", error);
        return { ok: false, error: error };
      });
  } catch (error) {
    // Handle network errors or unexpected issues
    console.error("Error during roles:", error);
    return { ok: false, error: error };
  }
};

export const getUserById = async (id) => {
  try {
    return await makeAuthenticatedRequest(`/users/${id}`, "GET")
      .then((response) => {
        // Check if the request was successful (status code 200-299)
        if (!response.ok) {
          return { ok: false, error: response };
        }
        // Parse the response as JSON
        return response.json();
      })
      .then((data) => {
        // Handle the JSON data
        return { ok: true, data: data };
      })
      .catch((error) => {
        // Handle errors
        console.error("Fetch error - liveClasses:", error);
        return { ok: false, error: error };
      });
  } catch (error) {
    // Handle network errors or unexpected issues
    console.error("Error during login:", error);
    return { ok: false, error: error };
  }
};

export const deleteUser = async (id) => {
  try {
    return await makeAuthenticatedRequest(`/users/${id}`, "DELETE")
      .then((response) => {
        // Check if the request was successful (status code 200-299)
        if (!response.ok) {
          return { ok: false, error: response };
        }
        // Parse the response as JSON
        return response.json();
      })
      .then((data) => {
        // Handle the JSON data
        return { ok: true, data: data };
      })
      .catch((error) => {
        // Handle errors
        console.error("Delete Live Class :", error);
        return { ok: false, error: error };
      });
  } catch (error) {
    // Handle network errors or unexpected issues
    console.error("Error during delete Live Class :", error);
    return { ok: false, error: error };
  }
};

export const createUser = async (payload) => {
  try {
    return await makeAuthenticatedRequest(`/users`, "POST", payload)
      .then((response) => {
        // Check if the request was successful (status code 200-299)
        if (!response.ok) {
          return response.text().then((text) => {
            return { ok: false, error: text };
          });
        }
        // Parse the response as JSON
        return response.json();
      })
      .then((data) => {
        // Handle the JSON data
        return { ok: true, data: data };
      })
      .catch((error) => {
        // Handle errors
        console.error("Create user  :", error);
        return { ok: false, error: error };
      });
  } catch (error) {
    // Handle network errors or unexpected issues
    console.error("Error during create user:", error);
    return { ok: false, error: error };
  }
};

export const updateUser = async (id, updatedData) => {
  try {
    return await makeAuthenticatedRequest(`/users/${id}`, "PATCH", updatedData)
      .then((response) => {
        // Check if the request was successful (status code 200-299)
        if (!response.ok) {
          return { ok: false, error: response };
        }
        // Parse the response as JSON
        return response.json();
      })
      .then((data) => {
        // Handle the JSON data
        return { ok: true, data: data };
      })
      .catch((error) => {
        // Handle errors
        console.error("Fetch error:", error);
        return { ok: false, error: error };
      });
  } catch (error) {
    // Handle network errors or unexpected issues
    console.error("Error during update User:", error);
    return { ok: false, error: error };
  }
};

export const updateUserBio = async (updatedData) => {
  try {
    const response = await makeAuthenticatedRequest(
      `/users/update_bio`,
      "POST",
      updatedData,
    );

    if (!response.ok) {
      // Extract error message from the response
      const errorData = await response.json();
      return { ok: false, error: errorData.error || "Unknown error occurred" }; // Extract the error message
    }

    const data = await response.json();
    return { ok: true, data: data };
  } catch (error) {
    console.error("Error during update User:", error);
    return { ok: false, error: error.message || "Failed to update profile" };
  }
};

export const getAllRoles = async () => {
  try {
    return await makeAuthenticatedRequest("/security_profiles", "GET")
      .then((response) => {
        // Check if the request was successful (status code 200-299)
        if (!response.ok) {
          return { ok: false, error: response };
        }
        // Parse the response as JSON
        return response.json();
      })
      .then((data) => {
        // Handle the JSON data
        return { ok: true, data: data };
      })
      .catch((error) => {
        // Handle errors
        console.error("Fetch error - roles:", error);
        return { ok: false, error: error };
      });
  } catch (error) {
    // Handle network errors or unexpected issues
    console.error("Error during roles:", error);
    return { ok: false, error: error };
  }
};

export const getAllSchools = async () => {
  try {
    return await makeAuthenticatedRequest("/schools", "GET")
      .then((response) => {
        // Check if the request was successful (status code 200-299)
        if (!response.ok) {
          return { ok: false, error: response };
        }
        // Parse the response as JSON
        return response.json();
      })
      .then((data) => {
        // Handle the JSON data
        return { ok: true, data: data };
      })
      .catch((error) => {
        // Handle errors
        console.error("Fetch error - schools:", error);
        return { ok: false, error: error };
      });
  } catch (error) {
    // Handle network errors or unexpected issues
    console.error("Error during schools:", error);
    return { ok: false, error: error };
  }
};
export const resetUserInfo = async (id) => {
  try {
    return await makeAuthenticatedRequest(`/users/reset_devices/${id}`, "PATCH")
      .then((response) => {
        // Check if the request was successful (status code 200-299)
        if (!response.ok) {
          return { ok: false, error: response };
        }
        // Parse the response as JSON
        return response.json();
      })
      .then((data) => {
        // Handle the JSON data
        return { ok: true, data: data };
      })
      .catch((error) => {
        // Handle errors
        console.error("Fetch error:", error);
        return { ok: false, error: error };
      });
  } catch (error) {
    // Handle network errors or unexpected issues
    console.error("Error during update User:", error);
    return { ok: false, error: error };
  }
};

export const deactivateUser = async (id, updatedData) => {
  try {
    return await makeAuthenticatedRequest(`/users/${id}`, "PATCH", updatedData)
      .then((response) => {
        // Check if the request was successful (status code 200-299)
        if (!response.ok) {
          return { ok: false, error: response };
        }
        // Parse the response as JSON
        return response.json();
      })
      .then((data) => {
        // Handle the JSON data
        return { ok: true, data: data };
      })
      .catch((error) => {
        // Handle errors
        console.error("Fetch error:", error);
        return { ok: false, error: error };
      });
  } catch (error) {
    // Handle network errors or unexpected issues
    console.error("Error during update User:", error);
    return { ok: false, error: error };
  }
};

export const createNewRole = async (payload) => {
  try {
    return await makeAuthenticatedRequest(`/security_profiles`, "POST", payload)
      .then((response) => {
        // Check if the request was successful (status code 200-299)
        if (!response.ok) {
          return { ok: false, error: response };
        }
        // Parse the response as JSON
        return response.json();
      })
      .then((data) => {
        // Handle the JSON data
        return { ok: true, data: data };
      })
      .catch((error) => {
        // Handle errors
        console.error("Create role  :", error);
        return { ok: false, error: error };
      });
  } catch (error) {
    // Handle network errors or unexpected issues
    console.error("Error during create role:", error);
    return { ok: false, error: error };
  }
};

export const updateRole = async (roleId, payload) => {
  try {
    return await makeAuthenticatedRequest(
      `/security_profiles/${roleId}`,
      "PATCH",
      payload,
    )
      .then((response) => {
        // Check if the request was successful (status code 200-299)
        if (!response.ok) {
          return { ok: false, error: response };
        }
        // Parse the response as JSON
        return response.json();
      })
      .then((data) => {
        // Handle the JSON data
        return { ok: true, data: data };
      })
      .catch((error) => {
        // Handle errors
        console.error("Create role  :", error);
        return { ok: false, error: error };
      });
  } catch (error) {
    // Handle network errors or unexpected issues
    console.error("Error during create role:", error);
    return { ok: false, error: error };
  }
};

export const deleteRole = async (roleId) => {
  try {
    return await makeAuthenticatedRequest(
      `/security_profiles/${roleId}`,
      "DELETE",
    )
      .then((response) => {
        // Check if the request was successful (status code 200-299)
        if (!response.ok) {
          return { ok: false, error: response };
        }
        // Parse the response as JSON
        return response.json();
      })
      .then((data) => {
        // Handle the JSON data
        return { ok: true, data: data };
      })
      .catch((error) => {
        // Handle errors
        console.error("delete role  :", error);
        return { ok: false, error: error };
      });
  } catch (error) {
    // Handle network errors or unexpected issues
    console.error("Error during delete role:", error);
    return { ok: false, error: error };
  }
};

export const updateNotificationSettings = async (
  userId,
  notificationSettings,
) => {
  try {
    const response = await makeAuthenticatedRequest(
      `/users/notification_settings/${userId}`,
      "PATCH",
      JSON.stringify(notificationSettings),
    );
    if (!response.ok) {
      const errorData = await response.json();
      return { ok: false, error: errorData.error || "Unknown error occurred" };
    }
    const data = await response.json();
    return { ok: true, data };
  } catch (error) {
    console.error("Error updating notification settings:", error);
    return { ok: false, error: error.message || "Failed to update settings" };
  }
};

export const createBulkUser = async (payload) => {
  try {
    return await makeAuthenticatedRequestForFile(
      `/users/bulk_create`,
      "POST",
      payload,
    )
      .then(async (response) => {
        if (!response.ok) {
          const error = await response.json(); // Await the promise here
          return { ok: false, error };
        }
        const data = await response.json();
        return { ok: true, data };
      })
      .catch((error) => {
        console.error("Create user  :", error);
        return { ok: false, error };
      });
  } catch (error) {
    console.error("Error during create user:", error);
    return { ok: false, error };
  }
};

export const importUser = async (payload) => {
  try {
    return await makeAuthenticatedRequest(`/classrooms/import`, "POST", payload)
      .then((response) => {
        // Check if the request was successful (status code 200-299)
        if (!response.ok) {
          return { ok: false, error: response };
        }
        // Parse the response as JSON
        return response.json();
      })
      .then((data) => {
        // Handle the JSON data
        return { ok: true, data: data };
      })
      .catch((error) => {
        // Handle errors
        console.error("Students import Failed  :", error);
        return { ok: false, error: error };
      });
  } catch (error) {
    // Handle network errors or unexpected issues
    console.error("Students import Failed:", error);
    return { ok: false, error: error };
  }
};

export const getStudentsOfClassroom = async (props) => {
  const { classroomId } = props;

  try {
    return await makeAuthenticatedRequest(`/classrooms/${classroomId}`, "GET")
      .then((response) => {
        // Check if the request was successful (status code 200-299)
        if (!response.ok) {
          return { ok: false, error: response };
        }
        // Parse the response as JSON
        return response.json();
      })
      .then((data) => {
        // Handle the JSON data
        return { ok: true, data: data };
      })
      .catch((error) => {
        // Handle errors
        console.error("Fetch error students of a classroom:", error);
        return { ok: false, error: error };
      });
  } catch (error) {
    // Handle network errors or unexpected issues
    console.error("Error during  students of a classroom:", error);
    return { ok: false, error: error };
  }
};

export const getSecurityPermissions = async () => {
  try {
    return await makeAuthenticatedRequest(`/security_permissions`, "GET")
      .then((response) => {
        // Check if the request was successful (status code 200-299)
        if (!response.ok) {
          return { ok: false, error: response };
        }
        // Parse the response as JSON
        return response.json();
      })
      .then((data) => {
        // Handle the JSON data
        return { ok: true, data: data };
      })
      .catch((error) => {
        // Handle errors
        console.error("Fetch error - liveClasses:", error);
        return { ok: false, error: error };
      });
  } catch (error) {
    // Handle network errors or unexpected issues
    console.error("Error during login:", error);
    return { ok: false, error: error };
  }
};

export const getPermissionsForRole = async (id) => {
  try {
    return await makeAuthenticatedRequest(
      `/security_permissions/role/${id}`,
      "GET",
    )
      .then((response) => {
        // Check if the request was successful (status code 200-299)
        if (!response.ok) {
          return { ok: false, error: response };
        }
        // Parse the response as JSON
        return response.json();
      })
      .then((data) => {
        // Handle the JSON data
        return { ok: true, data: data };
      })
      .catch((error) => {
        // Handle errors
        console.error("Fetch error - liveClasses:", error);
        return { ok: false, error: error };
      });
  } catch (error) {
    // Handle network errors or unexpected issues
    console.error("Error during login:", error);
    return { ok: false, error: error };
  }
};

export const savePermissions = async (id, payload) => {
  try {
    return await makeAuthenticatedRequest(
      `/security_permissions/role/${id}`,
      "POST",
      payload,
    )
      .then((response) => {
        // Check if the request was successful (status code 200-299)
        if (!response.ok) {
          return { ok: false, error: response };
        }
        // Parse the response as JSON
        return response.json();
      })
      .then((data) => {
        // Handle the JSON data
        return { ok: true, data: data };
      })
      .catch((error) => {
        // Handle errors
        console.error("Create permissions  :", error);
        return { ok: false, error: error };
      });
  } catch (error) {
    // Handle network errors or unexpected issues
    console.error("Error during saving permissions :", error);
    return { ok: false, error: error };
  }
};
